import * as Yup from 'yup'
import { pt } from 'yup-locale-pt';

import { CPFValidator, CNPJValidator } from './../../utils'

Yup.setLocale(pt);

export default Yup.object().shape({
  name: Yup.string().max(150).required().label('Nome completo'),
  email: Yup.string().email().required().label('E-mail'),
  phone_1: Yup.string().max(45).required().label('Telefone principal'),

  cpf: Yup.string().required().test('CPF', 'CPF inválido', CPFValidator.validate).label('CPF'),
  cnpj: Yup.string().required().test('CNPJ', 'CNPJ inválido', CNPJValidator.validate).label('CNPJ')
})